<div class="ion-justify-content-center ion-text-center child">
  <img src="assets/images/download-dpi.png" />
  <h1 class="">Downloading updates</h1>
  <p class="ion-text-center ov-auto">A new version of the app is available. Please wait while the updates are being downloaded.</p>
  <p class="ion-text-center ov-auto">Download progress {{ progressValue * 100 | number: '1.0-0' }}%</p>
  <ion-progress-bar [value]="progressValue" color="danger"></ion-progress-bar>
</div>
